module.exports = __WEBPACK_EXTERNAL_MODULE__wordpress_interactivity_8e89b257__;